import {PrivzetaVrednostTipEnum} from '../../Enum/PrivzetaVrednostTipEnum'
import PrivzetaVrednostLogic from '../PrivzetaVrednostLogic'

export const PridobiStranko = {
  methods: {
    GetUserData () {
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info?',
        param,
        null,
        'SetUserData',
        'ErrUserData')
    },
    SetUserData (podatki) {
      let osebniPodatki = podatki
      let nalaganje = false

      PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(PrivzetaVrednostTipEnum.SAP, osebniPodatki.defaultSubscription)
      for (const index in osebniPodatki.defaultConnectors) {
        PrivzetaVrednostLogic.getInstance().ShraniPrivzetoVrednost(index, osebniPodatki.defaultConnectors[index])
      }
      this.PrenosniPodatkiStranka(osebniPodatki, nalaganje)
    },
    ErrUserData (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko.js